<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsCommutesNoCommutingDays.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'CommutesNoCommutingDays',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = new Array(8).fill(0)
      let tseries = {}
      let nAnswers = {}
      let normalizationFactor = {}
      for (let position of this.ghgi.boundary.positions) {
        tseries[position] = new Array(8).fill(0)
        nAnswers[position] = 0
        normalizationFactor[position] = 0
      }
      for (let commute of this.ghgi.commutes) {
        if (!commute.cdeleted) {
          nAnswers[commute.position] += 1
          tseries[commute.position][commute.nWorkingDay] += 1
        }
      }
      for (let index in series) {
        for (let position of Object.keys(tseries)) {
          if (nAnswers[position] !== 0) {
            let normalizationFactor =
              this.ghgi.boundary.positionNormalizationFactor(
                position,
                nAnswers[position]
              )
            series[index] += tseries[position][index] * normalizationFactor
          }
        }
      }
      return series
    },
    categories: function () {
      const self = this
      return [...Array(8).keys()].map(
        (value) =>
          value + ' ' + self.$t('compGraphicsCommutesNoCommutingDays.label-3')
      )
    },
    options: function () {
      const self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return (
              '<b>' +
              Math.round(this.y) +
              '</b> ' +
              self.$t('compGraphicsCommutesNoCommutingDays.tooltip') +
              '<b> ' +
              this.x +
              '</b>'
            )
          }
        },
        xAxis: {
          categories: this.categories,
          crosshair: true,
          title: {
            text: this.$t('compGraphicsCommutesNoCommutingDays.label-1')
          }
        },
        yAxis: [
          {
            gridLineWidth: 0,
            title: {
              text: this.$t('compGraphicsCommutesNoCommutingDays.label-2')
            }
          }
        ],
        plotOptions: {
          column: {
            pointPadding: 0,
            borderWidth: 0
          }
        },
        series: [
          {
            type: 'column',
            data: this.series
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
